// Bilingual translations for Learn AI Once a Week
const translations = {
  en: {
    // Nav
    brand: 'Learn AI Once a Week',
    brand_short: 'LearnAI',
    sign_in: 'Sign In',
    get_started: 'Get Started',
    sign_out: 'Sign Out',

    // Hero
    hero_badge: 'Weekly AI learning for teams and groups',
    hero_title_1: 'Learn AI in a practical way,',
    hero_title_2: 'one session every week.',
    hero_subtitle: 'For companies, communities, and parents who want simple AI learning that people can actually use in daily work and study.',
    hero_cta: 'Start Your Group',
    hero_cta2: 'See What We Teach',
    hero_card_title: 'What is included',
    hero_price: '₹3,000',
    hero_price_sub: 'per month · up to 30 people · incl. GST',

    // Cohort types
    for_companies: 'For Companies',
    for_communities: 'For Communities & NGOs',
    for_parents: 'For Kids, Women & Seniors',
    companies_desc: 'Help your team learn useful AI tools with one live session every week.',
    communities_desc: 'Help members, educators, and volunteers learn AI in a simple way.',
    parents_desc: 'Create a simple AI learning group for students, homemakers, and seniors.',

    // How it works
    how_title: 'From sign-up to first session in 48 hours',
    how_sub: 'We help with trainer matching, planning, and scheduling so your group can start smoothly.',
    step1_title: 'Tell us about your group',
    step1_desc: 'Share who will learn, what they need, and your preferred day and time.',
    step2_title: 'Complete payment',
    step2_desc: 'Secure your group so we can start planning sessions and trainer matching.',
    step3_title: 'Choose topics',
    step3_desc: 'Pick from ready topics or choose a package that fits your needs.',
    step4_title: 'Trainer gets assigned',
    step4_desc: 'We match you with the right trainer based on audience and goals.',
    step5_title: 'Learn every week',
    step5_desc: 'Attend live sessions, get notes and recordings, and keep improving step by step.',

    // What you learn
    learn_title: 'What your group will learn',
    learn_sub: 'Simple, useful AI skills across key areas. Practical sessions, not technical theory.',

    // Pricing
    pricing_title: 'Simple plans for regular AI learning',
    pricing_sub: 'Choose the plan that fits your budget and pace. Every plan includes live sessions, learning materials, and support.',
    pricing_amount: '₹3,000',
    pricing_period: '/month',
    pricing_tagline: 'For up to 30 people · Includes GST',
    pricing_features: [
      '4 live sessions per month (once a week)',
      'Expert AI tools trainer, matched to your team',
      'Practical curriculum based on your learning goals',
      'Session recordings & notes',
      'WhatsApp/email support between sessions',
      'Progress tracking dashboard',
      'Clear pricing and guided onboarding'
    ],
    pricing_cta: 'Start Learning',

    // Form
    form_title: 'Set up your group',
    form_subtitle: 'Share a few details so we can set up the right group, trainer, and weekly schedule.',
    cohort_type_label: 'Who is this for?',
    org_name: 'Organisation Name',
    org_name_ph: 'Acme Corp / Green NGO / My Students',
    city: 'City',
    city_ph: 'Mumbai',
    industry: 'Sector',
    team_size: 'Number of Learners (max 30)',
    contact_name: 'Main Contact Name',
    contact_email: 'Email',
    contact_phone: 'WhatsApp Number',
    password_label: 'Account Password',
    goals: 'What should your learners be able to do after these sessions?',
    goals_ph: 'e.g. write better emails with AI, save time on repeat work, make better classroom content, or use prompts clearly...',
    language_pref: 'Preferred Session Language',
    lang_en: 'English',
    lang_hi: 'Hindi',
    lang_both: 'Both (Hinglish)',
    preferred_day: 'Preferred Day',
    preferred_time: 'Preferred Time',
    submit_btn: 'Continue to Payment →',
    submitting: 'Setting up your group...',

    // Payment
    payment_title: 'Complete Payment',
    payment_subtitle: 'Secure checkout · quick activation after payment',
    payment_secure: 'Secured by Razorpay',
    payment_test_badge: 'TEST MODE',
    payment_amount: '₹3,000',
    payment_gst: 'Includes GST',
    payment_includes: 'What\'s included:',
    pay_now: 'Continue to Payment',
    use_test: 'Use Test Card',
    processing: 'Processing...',
    payment_success: 'Payment Successful!',
    payment_success_msg: 'Your group is now active. Let\'s choose the topics.',

    // Dashboard
    dashboard_title: 'Dashboard',
    batch_of: 'Batch of',
    people: 'people',
    payment_pending_title: 'Complete Payment to Start',
    payment_pending_desc: 'Your group is ready. Complete payment to unlock trainer matching and live session booking.',
    complete_payment: 'Continue to Payment',
  },

  hi: {
    // Nav
    brand: 'AI हर हफ़्ते सीखें',
    brand_short: 'LearnAI',
    sign_in: 'साइन इन करें',
    get_started: 'शुरू करें',
    sign_out: 'साइन आउट',

    // Hero
    hero_badge: 'भारत का सबसे किफायती AI प्रशिक्षण',
    hero_title_1: 'आपकी टीम, AI का उपयोग',
    hero_title_2: 'हर हफ्ते।',
    hero_subtitle: '₹3,000/महीना, 30 लोगों तक। हर हफ्ते एक एक्सपर्ट सेशन। कोई कोडिंग नहीं। कोई जटिल भाषा नहीं। बस व्यावहारिक AI कौशल।',
    hero_cta: '₹3,000/महीना से शुरू करें',
    hero_cta2: 'क्या सिखाते हैं देखें',
    hero_card_title: 'सब कुछ शामिल',
    hero_price: '₹3,000',
    hero_price_sub: 'प्रति माह · 30 लोगों तक · GST सहित',

    // Cohort types
    for_companies: 'कंपनियों के लिए',
    for_communities: 'समुदायों और NGO के लिए',
    for_parents: 'बच्चे, महिलाएं और वरिष्ठ के लिए',
    companies_desc: 'अपने कर्मचारियों को AI से कुशल बनाएं।',
    communities_desc: 'अपने सदस्यों को AI सशक्त बनाएं।',
    parents_desc: 'छात्रों, गृहिणियों और वरिष्ठों के लिए कोहोर्ट बनाएं।',

    // How it works
    how_title: '48 घंटे में पहले सेशन तक',
    how_sub: 'ट्रेनर मैचिंग, शेड्यूलिंग और पाठ्यक्रम हम संभालते हैं।',
    step1_title: 'अपनी टीम के बारे में बताएं',
    step1_desc: 'अपने लक्ष्य और पसंदीदा समय बताएं। 2 मिनट लगते हैं।',
    step2_title: '₹3,000 का भुगतान करें',
    step2_desc: 'सुरक्षित भुगतान। कोई छुपी फीस नहीं।',
    step3_title: 'AI आपके विषय चुनता है',
    step3_desc: 'हमारा AI आपकी टीम की जरूरत के हिसाब से पाठ्यक्रम बनाता है।',
    step4_title: 'एक्सपर्ट ट्रेनर असाइन',
    step4_desc: '48 घंटे में आपका AI ट्रेनर कन्फर्म हो जाता है।',
    step5_title: 'साप्ताहिक सेशन शुरू',
    step5_desc: 'हर सेशन रिकॉर्ड होता है और अगले के लिए अनुकूलित होता है।',

    // What you learn
    learn_title: 'आपकी टीम क्या सीखेगी',
    learn_sub: '7 क्षेत्रों में व्यावहारिक कौशल। सब हाथों से। कोई कोडिंग नहीं।',

    // Pricing
    pricing_title: 'सरल, ईमानदार कीमत',
    pricing_sub: 'एक फ्लैट फीस। सब शामिल। कोई छुपा शुल्क नहीं।',
    pricing_amount: '₹3,000',
    pricing_period: '/महीना',
    pricing_tagline: '30 लोगों तक · GST शामिल',
    pricing_features: [
      'महीने में 4 लाइव सेशन (हर हफ्ते)',
      'आपकी टीम के लिए मैच किया हुआ AI ट्रेनर',
      'AI-जनरेटेड कस्टम पाठ्यक्रम',
      'सेशन रिकॉर्डिंग और नोट्स',
      'WhatsApp/ईमेल सपोर्ट',
      'प्रगति ट्रैकिंग डैशबोर्ड',
      'कभी भी रद्द करें'
    ],
    pricing_cta: 'सीखना शुरू करें — ₹3,000/महीना',

    // Form
    form_title: 'अपना ग्रुप सेट करें',
    form_subtitle: 'अपने समूह और लक्ष्यों के बारे में बताएं।',
    cohort_type_label: 'यह किसके लिए है?',
    org_name: 'संगठन का नाम',
    org_name_ph: 'Acme Corp / Green NGO / मेरे छात्र',
    city: 'शहर',
    city_ph: 'मुंबई',
    industry: 'क्षेत्र',
    team_size: 'सीखने वालों की संख्या (अधिकतम 30)',
    contact_name: 'आपका नाम',
    contact_email: 'ईमेल',
    contact_phone: 'WhatsApp नंबर',
    password_label: 'अकाउंट पासवर्ड',
    goals: 'इसके बाद आपकी टीम क्या कर पाएगी?',
    goals_ph: 'जैसे: AI से बेहतर ईमेल लिखना, रोज 2 घंटे बचाना, दोहराने वाले काम ऑटोमेट करना...',
    language_pref: 'पसंदीदा सेशन भाषा',
    lang_en: 'English',
    lang_hi: 'हिंदी',
    lang_both: 'दोनों (Hinglish)',
    preferred_day: 'पसंदीदा दिन',
    preferred_time: 'पसंदीदा समय',
    submit_btn: 'भुगतान की ओर जारी रखें →',
    submitting: 'कोहोर्ट सेट हो रहा है...',

    // Payment
    payment_title: 'भुगतान पूरा करें',
    payment_subtitle: 'एकमुश्त सेटअप · ₹3,000/माह',
    payment_secure: 'Razorpay द्वारा सुरक्षित',
    payment_test_badge: 'टेस्ट मोड',
    payment_amount: '₹3,000',
    payment_gst: 'GST सहित',
    payment_includes: 'क्या शामिल है:',
    pay_now: '₹3,000 दें — वर्कशॉप सक्रिय करें',
    use_test: 'टेस्ट कार्ड उपयोग करें',
    processing: 'प्रोसेस हो रहा है...',
    payment_success: 'भुगतान सफल!',
    payment_success_msg: 'आपकी वर्कशॉप अब सक्रिय है। विषय चुनें!',

    // Dashboard
    dashboard_title: 'मेरी वर्कशॉप',
    batch_of: 'बैच',
    people: 'लोग',
    payment_pending_title: 'शुरू करने के लिए भुगतान करें',
    payment_pending_desc: 'वर्कशॉप सेट है। सेशन सक्रिय करने के लिए ₹3,000 दें।',
    complete_payment: 'भुगतान करें — ₹3,000',
  }
};

export default translations;
